import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { hydrateTheme } from '@apps-common/theme/hydrateTheme'
import type { PortalThemeModel } from '@apps-common/types/portal/theme'

type UploadFile = { key: string; file: any }

const createOrUpdateMyMonitoringTheme = async (model: PortalThemeModel, files: UploadFile[]): Promise<PortalThemeModel> => {
  const hydrated = hydrateTheme(model)

  const formData = new FormData()

  // Attach logo files
  for (const f of files) {
    if (f.file) {
      formData.append(f.key, f.file?.blob || f.file)
    }
  }

  // Required fields for the new API
  formData.append('companyId', hydrated.companyId)
  formData.append('themeSchemaVersion', String(hydrated.themeSchemaVersion ?? 2))
  formData.append('palettesJson', hydrated.palettesJson)

  const res = await axios.post(`/my-monitoring/management/UpdatePortalTheme`, formData)
  const data = res?.data

  if (data?.result && data?.data) {
    return hydrateTheme(data.data)
  }

  throw new Error(data?.msg || 'Theme update failed')
}

type Props = {
  model: PortalThemeModel
  files: UploadFile[]
}

export const useMyMonitoringManagementThemeCreateOrUpdate = (notify?: boolean, onSuccess?: (data: PortalThemeModel) => void) =>
  useMutation({
    mutationKey: ['createOrUpdateMyMonitoringTheme'],
    mutationFn: ({ model, files }: Props) => createOrUpdateMyMonitoringTheme(model, files),
    onSuccess: (data) => {
      onSuccess?.(data)
      if (notify) toastSuccess('Updated theme.')
    },
    onError: (error) => {
      if (notify) toastError(error?.message || 'Failed to update theme, please try again.')
    }
  })
